/*
 *  ~ Copyright (c) by INFODATA-GROUP. All rights reserved.
 *  ~ No part of this publication may be reproduced, distributed,
 *  ~ or transmitted in any form or by any means, including photocopying, recording,
 *  ~ or other electronic or mechanical methods, without the prior written permission of the publisher,
 *  ~ except in the case of brief quotations embodied in critical
 *  ~ reviews and certain other noncommercial uses permitted by copyright law.
 *  ~ Author : BS
 *  ~ Date : 2/8/23, 11:19 AM
 */

import { Entity } from '@infodata-group/inf-commons';
import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import { AoSharedTools } from '../../engine/tools/ao-shared-tools';
import { ReportTypeEnum } from '../../enum/report-type.enum';
import { ReportExportInterface } from '../../interface/report/report-export.interface';
import { AoReportDetail } from './ao-report-detail';

dayjs.extend(localizedFormat);

export class AoReport extends Entity {
  id: string;
  date: string;
  start: string;
  end: string;
  sal: string;
  salId: string;
  bbx: string;
  totalTemps: string;
  totalDeplacement: string;
  totalChantier: string;
  totalPause: string;
  totalTravail: string;
  vitesseMoyenne: number;
  vitesseMaximum: number;
  freinageBrutaux = 0;
  accelerationBrutales = 0;
  coteConducteur = 0;
  km: number;
  totalKm: number;
  detail: AoReportDetail[] = [];
  type = ReportTypeEnum.employee;

  public get label(): string {
    return this.getLabel();
  }

  constructor(id: string) {
    super();
    this.id = id;
  }

  getId(): string {
    return this.id;
  }

  getDate(): Date {
    return dayjs(this.date).toDate();
  }

  getLabel(): string {
    let label = this.sal;
    if (this.salId) {
      label = `${label} (${this.salId})`;
    }
    return label;
  }

  getTotalTempsComputed(): string {
    return AoSharedTools.convertSecondsDurationToString(
      AoSharedTools.convertStringDurationToSeconds(this.totalTemps),
    );
  }
  getTotalDeplacementComputed(): string {
    return AoSharedTools.convertSecondsDurationToString(
      AoSharedTools.convertStringDurationToSeconds(this.totalDeplacement),
    );
  }
  getTotalChantierComputed(): string {
    return AoSharedTools.convertSecondsDurationToString(
      AoSharedTools.convertStringDurationToSeconds(this.totalChantier),
    );
  }
  getTotalPauseComputed(): string {
    return AoSharedTools.convertSecondsDurationToString(
      AoSharedTools.convertStringDurationToSeconds(this.totalPause),
    );
  }
  getTotalTravailComputed(): string {
    return AoSharedTools.convertSecondsDurationToString(
      AoSharedTools.convertStringDurationToSeconds(this.totalTravail),
    );
  }

  serialize(): any {}

  toExport(): ReportExportInterface[] {
    const array = [];
    for (const detail of this.detail) {
      array.push({
        date: this.date,
        employee: this.sal,
        bbx: this.bbx,
        ...detail.toExport(),
        getId: () => null,
        getLabel: () => null,
      });
    }
    return array;
  }

  public getDeviceId(): string {
    return this.bbx;
  }
}
